import React from 'react';
import Navigation from './Navigation';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { user } = useAuth();
  
  // List of public paths that don't require authentication
  const publicPaths = ['/pricing'];
  const isPublicPath = publicPaths.includes(location.pathname);

  // If it's not a public path and user is not authenticated, show loading
  if (!isPublicPath && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="container mx-auto px-4 py-8 pt-24 max-w-7xl">
        {children}
      </main>
    </div>
  );
}